import { userInfoSync } from 'hub-http/userInfo';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file

import { isLegacyObjectType } from 'customer-data-objects/types/LegacyObjectType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import { useMemo } from 'react';
import { fromJS } from 'immutable';
import useEnrollSequence from 'crm-activity-creator-widgets/buttons/sequence/hooks/useEnrollSequence';
import { getFullUrl } from 'hubspot-url-utils';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
const getSalesModalIframeUrl = portalId => `${getFullUrl(enviro.debug('local-url') ? 'local' : 'app')}/sequence-enroll/${portalId}/embedded`;
const EnrollInSequenceModal = ({
  objectType,
  recipient,
  objectId,
  handleCloseModal
}) => {
  const [enrollSequence] = useEnrollSequence();
  const {
    user,
    portal
  } = userInfoSync();
  const isCrmObject = !isLegacyObjectType(objectType);
  const handleOnMessage = message => {
    const {
      payload: {
        type,
        singleEnrollResult,
        error,
        sequenceName
      }
    } = message;
    if (type === 'CLOSE') {
      handleCloseModal();
    } else if (type === 'CONFIRM') {
      handleCloseModal();
    } else if (type === 'SINGLE_ENROLL_COMPLETED' || type === 'SINGLE_ENROLL_FAILED') {
      const result = singleEnrollResult ? fromJS(singleEnrollResult) : null;
      enrollSequence({
        enrollment: result,
        sequenceName,
        err: error
      });
    }
  };
  const embeddedPassthruProps = useMemo(() => {
    if (!user) {
      return {};
    }
    const sharedProps = {
      selectConnectedAccount: true,
      useCachedConnectedAccount: true,
      platform: 'CRM',
      renderModalContainer: true,
      recipient,
      supplementalObjectType: isCrmObject ? null : objectType,
      supplementalObjectId: isCrmObject ? null : objectId
    };
    return sharedProps;
  }, [recipient, user, isCrmObject, objectType, objectId]);
  return /*#__PURE__*/_jsx(ModalIFrame, {
    "data-test-id": "enroll-modal-iframe",
    src: getSalesModalIframeUrl(portal.portal_id),
    onReady: () => {},
    onClose: () => {},
    onMessage: handleOnMessage,
    embeddedPassthruProps: embeddedPassthruProps,
    width: "980",
    height: "700"
  });
};
export default EnrollInSequenceModal;